import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';

import { useDefaultLayout } from '../../model/useDefaultLayout';
import LnbCollapseTriggerButton from './LnbCollapseTriggerButton';
import LnbServiceTitle from './LnbServiceTitle';
import MenuListItem from './menu-list-item';

import type { LnbContainerProps } from './types';

import { useServiceMenu } from '@/shared/hooks';

export default function Lnb() {
  const { collapsed, toggleCollapsed } = useDefaultLayout();
  const { name, targetLnbBadges, keyword, menus } = useServiceMenu();
  return (
    <LnbContainer container flexDirection={'column'} component={'section'} collapsed={collapsed}>
      <LnbServiceTitle
        collapsed={collapsed}
        keyword={keyword}
        name={name}
        targetLnbBadges={targetLnbBadges}
      />
      <LnbScrollAreaContainer container flexDirection={'column'}>
        {menus.map(menu => (
          <MenuListItem key={menu.path} menu={menu} collapsed={collapsed} />
        ))}
      </LnbScrollAreaContainer>
      <LnbCollapseTriggerButton collapsed={collapsed} onCollapse={toggleCollapsed} />
    </LnbContainer>
  );
}

const LnbContainer = styled(Grid, {
  shouldForwardProp: prop => prop !== 'collapsed',
})<LnbContainerProps>`
  ${({ collapsed, theme }) => css`
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: ${collapsed ? 56 : 256}px;
    background-color: ${theme.color['surface/neutral/weak/default']};
  `}
`;

const LnbScrollAreaContainer = styled(Grid)`
  flex: 1 1 0;
  overflow-x: hidden;
  overflow-y: auto;

  scrollbar-width: thin; // Firefox를 위한 설정
  scrollbar-color: #cccccc transparent; // Firefox를 위한 설정

  &::-webkit-scrollbar {
    width: 14px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cccccc;
    background-clip: padding-box;
    border: 4px solid transparent;
    border-radius: 8px;
  }
`;
